var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSinginCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2099_1172)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    transform: "matrix(-1 0 0 1 32 0)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 17.1667L11.9168 21.25C11.7641 21.4028 11.5696 21.4792 11.3335 21.4792C11.0974 21.4792 10.9029 21.4028 10.7502 21.25C10.5974 21.0972 10.521 20.9028 10.521 20.6667C10.521 20.4306 10.5974 20.2361 10.7502 20.0833L14.8335 16L10.7502 11.9167C10.5974 11.7639 10.521 11.5695 10.521 11.3333C10.521 11.0972 10.5974 10.9028 10.7502 10.75C10.9029 10.5972 11.0974 10.5208 11.3335 10.5208C11.5696 10.5208 11.7641 10.5972 11.9168 10.75L16.0002 14.8333L20.0835 10.75C20.2363 10.5972 20.4307 10.5208 20.6668 10.5208C20.9029 10.5208 21.0974 10.5972 21.2502 10.75C21.4029 10.9028 21.4793 11.0972 21.4793 11.3333C21.4793 11.5695 21.4029 11.7639 21.2502 11.9167L17.1668 16L21.2502 20.0833C21.4029 20.2361 21.4793 20.4306 21.4793 20.6667C21.4793 20.9028 21.4029 21.0972 21.2502 21.25C21.0974 21.4028 20.9029 21.4792 20.6668 21.4792C20.4307 21.4792 20.2363 21.4028 20.0835 21.25L16.0002 17.1667Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2099_1172",
    x: -54,
    y: -54,
    width: 140,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 27
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2099_1172"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2099_1172",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinginCloseButton);
export default __webpack_public_path__ + "static/media/singinCloseButton.1655bd0e1849416ccd21fd978cf5937b.svg";
export { ForwardRef as ReactComponent };